import Transaction from "./components/Transaction";
import './App.css';
import FormComponent from "./components/FormCoomponent";
import {useState,useEffect} from 'react';
import DataContext from "./data/DataContext";
import ReportComponent from "./components/ReportComponent";
import {BrowserRouter as Router,Route,Link,Routes} from "react-router-dom";

function App() {
/*
  const initData = [ 
    {id:1,title:"เงินเดือน",amount:25000},
    {id:2,title:"ค่าเช่าห้อง",amount:-4500},
    {id:3,title:"ค่าอาหาร",amount:-300},
    {id:4,title:"ของใช้",amount:-800},
    {id:5,title:"ทำยูทูป",amount:30800}
  ]
*/

  const [items,setItems]=useState([])
  const [reportIncome,setReportIncome]=useState(0);
  const [reportExpense,setReportExpense]=useState(0);
  
  const onAddNewItem = (newItem)=>{//เพิ่ม
    setItems((prevItem)=>{
      return [newItem,...prevItem]
    })
  }
  //49 คำนวนรายรับรายจ่าย
  useEffect(()=>{
    const amounts =items.map(items=>items.amount);
    console.log(amounts)
    const incomez = amounts.filter(element=>element>0).reduce((total,element)=>total+=element,0);
    const expensez = (amounts.filter(element=>element<0).reduce((total,element)=>total+=element,0))*-1;

    console.log("รายได้",incomez);
    console.log("รายจ่าย",expensez);
    setReportIncome(incomez)
    setReportExpense(expensez)
  },[items,reportIncome,reportExpense])


  return (

    <DataContext.Provider value={{income:reportIncome,expense:reportExpense}}>
      <div className="container">
      <h1 style={{color:"red",textAlign:"center",fontSize:"1.5rem"}}>โปรแกรมบัญชีรายรับ - รายจ่าย</h1>
      <Router>
      <div>
        <ul className="horizontal-menu">
          <li><Link to="/">ข้อมูลบัญชี</Link></li>
          <li><Link to="/insert">บันทึกข้อมูล</Link></li>
        </ul>
        <Routes>
          <Route path="/" element={<ReportComponent />} />
          <Route path="/insert" element={
            <div>
              <FormComponent onAddItem={onAddNewItem} />
              <Transaction items={items} />
            </div>
          }/>
        </Routes>
      </div>
      </Router>

      </div>
    </DataContext.Provider>
  );
}

export default App;
